import React, { Dispatch, SetStateAction } from 'react';
import {
    CommercialError,
    CommercialPayload
} from '../../../../../../pages/dashboard/tradedocuments/tradeDocumentTypes/CommercialTypes';
import { Country } from '../../../../../../interfaces/Country';
import MethodDetails from '../../CommercialFomComponents/MethodDetails';
import TransportDetails from '../../CommercialFomComponents/TransportDetails';
import PortsDetails from '../../CommercialFomComponents/PortsDetails';
import DepatureDetails from '../../CommercialFomComponents/DepatureDetails';

export const StepTwo = ({
    updateField,
    payload,
    countries,
    isCountriesLoading,
    errors,
    setShowAddPartner
}: {
    updateField: (name: string, value: unknown) => void;
    payload: CommercialPayload;
    countries: Country[];
    errors: CommercialError;
    isCountriesLoading: boolean;
    setShowAddPartner: Dispatch<SetStateAction<boolean>>;
}) => {
    return (
        <div className='w-full flex flex-col gap-1'>
            <MethodDetails
                {...{
                    errors,
                    payload,
                    updateField,
                    countries,
                    isCountriesLoading,
                    setShowAddPartner
                }}
            />

            <TransportDetails
                {...{
                    payload,
                    updateField,
                    errors,
                    countries,
                    isCountriesLoading,
                    setShowAddPartner
                }}
            />

            <PortsDetails
                {...{
                    payload,
                    updateField,
                    errors,
                    setShowAddPartner
                }}
            />

            <DepatureDetails
                {...{
                    payload,
                    updateField,
                    errors,
                    setShowAddPartner
                }}
            />
        </div>
    );
};
